import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface AlertaPreditivo {
  id: string;
  contrato_id: string;
  codigo: string;
  titulo: string;
  descricao: string | null;
  severidade: string;
  dados_contexto: Record<string, any>;
  ativo: boolean;
  created_at: string;
}

export function useEmpAlertasPreditivos(contratoId: string | null) {
  return useQuery({
    queryKey: ['emp-alertas-preditivos', contratoId],
    queryFn: async (): Promise<AlertaPreditivo[]> => {
      if (!contratoId) return [];
      const { data, error } = await (supabase as any)
        .from('emp_alertas_preditivos')
        .select('*')
        .eq('contrato_id', contratoId)
        .eq('ativo', true)
        .order('created_at', { ascending: false });
      if (error) {
        console.debug('[PRED] Query error:', error.message);
        return [];
      }
      return (data ?? []) as AlertaPreditivo[];
    },
    enabled: !!contratoId,
    staleTime: 3 * 60 * 1000,
  });
}
